<template>
    <!--直播间分享-->
    <Modal
        :title="$t('liveRoomManagement.liveRoomList.Button.shareDialog.title')"
        :value="value"
        @input="$emit('input', $event)"
        @on-ok="openShortUrl(shareInfo.shortUrl)"
        :ok-text="$t('liveRoomManagement.liveRoomList.Button.shareDialog.okText')"
        width="580px"
    >
        <div style="width: 548px;margin-top: 10px">
            <Input v-model="shareInfo.shortUrl" readonly style="width: 444px" />
            <Button type="primary" ref="shortUrl" :data-clipboard-text="shareInfo.shortUrl">{{ $t('Button.copy.shortUrl') }}</Button>
            <Input v-model="shareInfo.playerUrl" readonly style="width: 432px;margin: 20px 0" />
            <Button
                type="primary"
                ref="playerUrl"
                :data-clipboard-text="shareInfo.playerUrl"
            >{{ $t('Button.copy.playerUrl') }}</Button>
            <Input v-model="shareInfo.commonCode" readonly style="width: 444px" />
            <Button
                type="primary"
                ref="commonCode"
                :data-clipboard-text="shareInfo.commonCode"
            >{{ $t('Button.copy.commonCode') }}</Button>
        </div>
        <div style="width: 548px;margin-top: 10px">
            <div style="width: 180px;margin: 0 auto">
                <canvas ref="qrcode"></canvas>
            </div>
        </div>
        <div v-if="isGZTV">
            <span style="color: red">{{ $t('Components.RoomShareModal.prompt') }}</span>
        </div>
    </Modal>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import api from "@/api/Api";
import extend from "extend";
import apimodel from "@/model/ApiModel";
import Clipboard from "clipboard";
import QRCode from "qrcode";
import config from "@/config";

export default {
    props: ["roomId", "value"],
    data() {
        return {
            clipboards: [],
            shareInfo: {
                shortUrl: "",
                playerUrl: "",
                commonCode: ""
            }
        };
    },
    computed: {
        ...mapState({
            isGZTV: state => state.config.profile == 'gztv'
        }),
    },
    watch: {
        value(value) {
            if (value) {
                this.loadShareInfo(this.roomId);
            }
        }
    },
    methods: {
        //直播间分享
        async loadShareInfo(id) {
            try {
            	let domain = this.$store.state.user.globalConfig.domainName || (config.domain + config.liveCms);

                domain = domain.split('|')[0].trim();
            	let domainSuffixIdx = domain.indexOf('/',9);

            	if(domainSuffixIdx > 0) {
            		domain = domain.substring(0, domainSuffixIdx);
            	}
            	let liveHtmlUrl = domain + config.liveHtmlUrl;

                let ret = await api.call("liveRoom/shareRoom", {
                    roomId: id
                });
                this.shareInfo.shortUrl = ret.data.shortUrl;
                this.shareInfo.playerUrl =
                    ret.data.domainName + config.liveHtmlUrl + "embed/player.html?roomID=" + id;
                this.shareInfo.commonCode =
                    '<iframe height="288" width="512" src="' +
                    ret.data.domainName + config.liveHtmlUrl+
                    "embed/player.html?roomID=" +
                    id +
                    '" frameborder="0" allowfullscreen></iframe>';
                this.useQrcode();
            } catch (e) {
                console.log(e);
            }
        },
        useQrcode() {
            let canvas = this.$refs.qrcode;
            QRCode.toCanvas(canvas, this.shareInfo.shortUrl, function(error) {
                if (error) console.error(error);
                console.log("QRCode success!");
            });
        },
        openShortUrl(url) {
            window.open(url, "_blank");
        },
        //复制
        initCopy() {
            let clipboards = [
                this.$refs.shortUrl.$el,
                this.$refs.playerUrl.$el,
                this.$refs.commonCode.$el
            ].map(btn => {
                let clipboard = new Clipboard(btn);
                clipboard.on("success", e => {
                    this.$Message.success(this.$t('Message.copy.success'));
                });
                clipboard.on("error", e => {
                    // 不支持复制
                    this.$Message.error(this.$t('Message.copy.nonsupport'));
                });
                return clipboard;
            });
            this.clipboards = clipboards;
        }
    },
    mounted() {
        this.initCopy();
    },
    beforeDestroy() {
        this.clipboards.forEach(c => c.destroy());
    }
};
</script>